<template>
  <div>
    <b-container class="self-assesment">
      <b-row>
        <b-col xl="10" offset-xl="1">
          <b-form @submit.prevent="">
            <!--Table No 1 STAFF BY LEVEL OF RESPONSIBILITY-->
            <fieldset>
              <div class="header">
                <template-status :status="status.assessment" />
                <div class="icon">
                  <img
                    src="/static/icons/SelfAssessment-Icons/staff_responsibility_icon.svg"
                    alt="algo"
                  />
                </div>
                <h4>
                  {{
                    $t("label_selfAssessment_staff_responsibility_numberTable")
                  }}
                </h4>
                <h2>
                  {{ $t("label_selfAssessment_staff_responsibility_title") }}
                  <template-tooltip
                    tooltip="label_selfAssessment_staff_responsibility_title_toolTip"
                  />
                </h2>
              </div>
              <div class="label">
                {{$t("label_selfAssessment_staff_responsibility_management_title")}}
                <template-tooltip
                  tooltip="label_selfAssessment_staff_responsibility_management_title_toolTip"
                />
              </div>
              <div class="table">
                <div class="row table-header">
                  <b-col cols="6" sm="8" md="8">
                    <p>
                      {{$t("label_selfAssessment_staff_responsibility_management_column_position")}}
                      <template-tooltip
                        tooltip="label_selfAssessment_staff_responsibility_management_column_position_toolTip"
                      />
                    </p>
                  </b-col>
                  <b-col cols="3" sm="2" md="2">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_staff_responsibility_management_column_women"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_staff_responsibility_management_column_women_toolTip"
                      />
                    </p>
                  </b-col>
                  <b-col cols="3" sm="2" md="2">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_staff_responsibility_management_column_men"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_staff_responsibility_management_column_men_toolTip"
                      />
                    </p>
                  </b-col>
                </div>
                <div class="row form-group self-assessment-table-column">
                  <div class="col-6 col-sm-8 col-md-8">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_staff_responsibility_management_executiveDirector"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_staff_responsibility_management_executiveDirector_toolTip"
                      />
                    </p>
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric
                      id="selfAssessment_staff_responsibility_management_executiveDirector_women"
                      v-model="
                        selfAssessment_staff_responsibility_management_executiveDirector_women
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderResponsabilitySA(
                          $event,
                          'SELF_ASSESSMENT_FIELDS_STAFF_RESPONSABILITY_LEADERSHIP',
                          'women'
                        )
                      "
                    />
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric
                      id="selfAssessment_staff_responsibility_management_executiveDirector_men"
                      v-model="
                        selfAssessment_staff_responsibility_management_executiveDirector_men
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderResponsabilitySA(
                          $event,
                          'SELF_ASSESSMENT_FIELDS_STAFF_RESPONSABILITY_LEADERSHIP',
                          'men'
                        )
                      "
                    />
                  </div>
                </div>
                <div class="row form-group self-assessment-table-column">
                  <div class="col-6 col-sm-8 col-md-8">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_staff_responsibility_management_director"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_staff_responsibility_management_director_toolTip"
                      />
                    </p>
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric
                      id="selfAssessment_staff_responsibility_management_director_women"
                      v-model="
                        selfAssessment_staff_responsibility_management_director_women
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderResponsabilitySA(
                          $event,
                          'SELF_ASSESSMENT_FIELDS_STAFF_RESPONSABILITY_LEADERSHIP',
                          'women'
                        )
                      "
                    />
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric
                      id="selfAssessment_staff_responsibility_management_director_men"
                      v-model="
                        selfAssessment_staff_responsibility_management_director_men
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderResponsabilitySA(
                          $event,
                          'SELF_ASSESSMENT_FIELDS_STAFF_RESPONSABILITY_LEADERSHIP',
                          'men'
                        )
                      "
                    />
                  </div>
                </div>
                <div class="row form-group self-assessment-table-column">
                  <div class="col-6 col-sm-8 col-md-8">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_staff_responsibility_management_middleLevel4"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_staff_responsibility_management_middleLevel4_toolTip"
                      />
                    </p>
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric
                      id="selfAssessment_staff_responsibility_management_middleLevel4_women"
                      v-model="
                        selfAssessment_staff_responsibility_management_middleLevel4_women
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderResponsabilitySA(
                          $event,
                          'SELF_ASSESSMENT_FIELDS_STAFF_RESPONSABILITY_LEADERSHIP',
                          'women'
                        )
                      "
                    />
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric
                      id="selfAssessment_staff_responsibility_management_middleLevel4_men"
                      v-model="
                        selfAssessment_staff_responsibility_management_middleLevel4_men
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderResponsabilitySA(
                          $event,
                          'SELF_ASSESSMENT_FIELDS_STAFF_RESPONSABILITY_LEADERSHIP',
                          'men'
                        )
                      "
                    />
                  </div>
                </div>
                <div class="row form-group self-assessment-table-column">
                  <div class="col-6 col-sm-8 col-md-8">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_staff_responsibility_management_middleLevel3"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_staff_responsibility_management_middleLevel3_toolTip"
                      />
                    </p>
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric
                      id="selfAssessment_staff_responsibility_management_middleLevel3_women"
                      v-model="
                        selfAssessment_staff_responsibility_management_middleLevel3_women
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderResponsabilitySA(
                          $event,
                          'SELF_ASSESSMENT_FIELDS_STAFF_RESPONSABILITY_LEADERSHIP',
                          'women'
                        )
                      "
                    />
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric
                      id="selfAssessment_staff_responsibility_management_middleLevel3_men"
                      v-model="
                        selfAssessment_staff_responsibility_management_middleLevel3_men
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderResponsabilitySA(
                          $event,
                          'SELF_ASSESSMENT_FIELDS_STAFF_RESPONSABILITY_LEADERSHIP',
                          'men'
                        )
                      "
                    />
                  </div>
                </div>
                <div class="row form-group self-assessment-table-column">
                  <div class="col-6 col-sm-8 col-md-8">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_staff_responsibility_management_middleLevel2"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_staff_responsibility_management_middleLevel2_toolTip"
                      />
                    </p>
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric
                      id="selfAssessment_staff_responsibility_management_middleLevel2_women"
                      v-model="
                        selfAssessment_staff_responsibility_management_middleLevel2_women
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderResponsabilitySA(
                          $event,
                          'SELF_ASSESSMENT_FIELDS_STAFF_RESPONSABILITY_LEADERSHIP',
                          'women'
                        )
                      "
                    />
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric
                      id="selfAssessment_staff_responsibility_management_middleLevel2_men"
                      v-model="
                        selfAssessment_staff_responsibility_management_middleLevel2_men
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderResponsabilitySA(
                          $event,
                          'SELF_ASSESSMENT_FIELDS_STAFF_RESPONSABILITY_LEADERSHIP',
                          'men'
                        )
                      "
                    />
                  </div>
                </div>
                <div class="row form-group self-assessment-table-column">
                  <div class="col-6 col-sm-8 col-md-8">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_staff_responsibility_management_middleLevel1"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_staff_responsibility_management_middleLevel1_toolTip"
                      />
                    </p>
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric
                      id="selfAssessment_staff_responsibility_management_middleLevel1_women"
                      v-model="
                        selfAssessment_staff_responsibility_management_middleLevel1_women
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderResponsabilitySA(
                          $event,
                          'SELF_ASSESSMENT_FIELDS_STAFF_RESPONSABILITY_LEADERSHIP',
                          'women'
                        )
                      "
                    />
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric
                      id="selfAssessment_staff_responsibility_management_middleLevel1_men"
                      v-model="
                        selfAssessment_staff_responsibility_management_middleLevel1_men
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderResponsabilitySA(
                          $event,
                          'SELF_ASSESSMENT_FIELDS_STAFF_RESPONSABILITY_LEADERSHIP',
                          'men'
                        )
                      "
                    />
                  </div>
                </div>
                <!--Subtotal leadership positions-->
                <div class="row form-group subtotal">
                  <div class="col-6 col-sm-8 col-md-8">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_staff_responsibility_management_subtotal"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_staff_responsibility_management_subtotal_toolTip"
                      />
                    </p>
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric
                      v-model="
                        selfAssessment_staff_responsibility_management_subtotal_women
                      "
                      readonly
                    />
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric
                      v-model="
                        selfAssessment_staff_responsibility_management_subtotal_men
                      "
                      readonly
                    />
                  </div>
                </div>
                <!--END-->
              </div>
              <div class="label">
                {{
                  $t(
                    "label_selfAssessment_staff_responsibility_otherPositions_title"
                  )
                }}
                <template-tooltip
                  tooltip="label_selfAssessment_staff_responsibility_otherPositions_title_tooltip"
                />
              </div>
              <div class="table">
                <div class="row form-group self-assessment-table-column">
                  <div class="col-6 col-sm-8 col-md-8">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_staff_responsibility_otherPositions_technical"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_staff_responsibility_otherPositions_technical_tooltip"
                      />
                    </p>
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric
                      id="selfAssessment_staff_responsibility_otherPositions_technical_women"
                      v-model="
                        selfAssessment_staff_responsibility_otherPositions_technical_women
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderResponsabilitySA(
                          $event,
                          'SELF_ASSESSMENT_FIELDS_STAFF_RESPONSABILITY_OTHER_POSITIONS',
                          'women'
                        )
                      "
                    />
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric
                      id="selfAssessment_staff_responsibility_otherPositions_technical_men"
                      v-model="
                        selfAssessment_staff_responsibility_otherPositions_technical_men
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderResponsabilitySA(
                          $event,
                          'SELF_ASSESSMENT_FIELDS_STAFF_RESPONSABILITY_OTHER_POSITIONS',
                          'men'
                        )
                      "
                    />
                  </div>
                </div>
                <div class="row form-group self-assessment-table-column">
                  <div class="col-6 col-sm-8 col-md-8">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_staff_responsibility_otherPositions_administrative"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_staff_responsibility_otherPositions_administrative_tooltip"
                      />
                    </p>
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric
                      id="selfAssessment_staff_responsibility_otherPositions_administrative_women"
                      v-model="
                        selfAssessment_staff_responsibility_otherPositions_administrative_women
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderResponsabilitySA(
                          $event,
                          'SELF_ASSESSMENT_FIELDS_STAFF_RESPONSABILITY_OTHER_POSITIONS',
                          'women'
                        )
                      "
                    />
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric
                      id="selfAssessment_staff_responsibility_otherPositions_administrative_men"
                      v-model="
                        selfAssessment_staff_responsibility_otherPositions_administrative_men
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderResponsabilitySA(
                          $event,
                          'SELF_ASSESSMENT_FIELDS_STAFF_RESPONSABILITY_OTHER_POSITIONS',
                          'men'
                        )
                      "
                    />
                  </div>
                </div>
                <div class="row form-group self-assessment-table-column">
                  <div class="col-6 col-sm-8 col-md-8">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_staff_responsibility_otherPositions_support"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_staff_responsibility_otherPositions_support_tooltip"
                      />
                    </p>
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric
                      id="selfAssessment_staff_responsibility_otherPositions_support_women"
                      v-model="
                        selfAssessment_staff_responsibility_otherPositions_support_women
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderResponsabilitySA(
                          $event,
                          'SELF_ASSESSMENT_FIELDS_STAFF_RESPONSABILITY_OTHER_POSITIONS',
                          'women'
                        )
                      "
                    />
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric
                      id="selfAssessment_staff_responsibility_otherPositions_suport_men"
                      v-model="
                        selfAssessment_staff_responsibility_otherPositions_suport_men
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderResponsabilitySA(
                          $event,
                          'SELF_ASSESSMENT_FIELDS_STAFF_RESPONSABILITY_OTHER_POSITIONS',
                          'men'
                        )
                      "
                    />
                  </div>
                </div>
                <div class="row form-group self-assessment-table-column">
                  <div class="col-6 col-sm-8 col-md-8">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_staff_responsibility_otherPositions_operational"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_staff_responsibility_otherPositions_operational_tooltip"
                      />
                    </p>
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric
                      id="selfAssessment_staff_responsibility_otherPositions_operational_women"
                      v-model="
                        selfAssessment_staff_responsibility_otherPositions_operational_women
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderResponsabilitySA(
                          $event,
                          'SELF_ASSESSMENT_FIELDS_STAFF_RESPONSABILITY_OTHER_POSITIONS',
                          'women'
                        )
                      "
                    />
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric
                      id="selfAssessment_staff_responsibility_otherPositions_operational_men"
                      v-model="
                        selfAssessment_staff_responsibility_otherPositions_operational_men
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderResponsabilitySA(
                          $event,
                          'SELF_ASSESSMENT_FIELDS_STAFF_RESPONSABILITY_OTHER_POSITIONS',
                          'men'
                        )
                      "
                    />
                  </div>
                </div>
                <!--Subtotal other positions-->
                <div class="row form-group subtotal">
                  <div class="col-6 col-sm-8 col-md-8">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_staff_responsibility_otherPositions_subtotal"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_staff_responsibility_otherPositions_subtotal_toolTip"
                      />
                    </p>
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric
                      v-model="
                        selfAssessment_staff_responsibility_otherPositions_subtotal_women
                      "
                      readonly
                    />
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric
                      v-model="
                        selfAssessment_staff_responsibility_otherPositions_subtotal_men
                      "
                      readonly
                    />
                  </div>
                </div>
                <!--END-->
                <div class="row form-group subtotal">
                  <div class="col-6 col-sm-8 col-md-8">
                    <p>
                      <strong>{{
                        $t("label_selfAssessment_staff_responsibility_total")
                      }}</strong>
                    </p>
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric
                      v-model="selfAssessment_staff_responsibility_total_women"
                      readonly
                    />
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric
                      v-model="selfAssessment_staff_responsibility_total_men"
                      readonly
                    />
                  </div>
                </div>
              </div>
            </fieldset>
            <!--END-->
            <!--Table No 2 STAFF BY DEPARTMENT-->
            <fieldset>
              <div class="header">
                <template-status :status="status.assessment" />
                <div class="icon">
                  <img
                    src="/static/icons/SelfAssessment-Icons/staff_department_icon.svg"
                    alt="algo"
                  />
                </div>
                <h4>
                  {{ $t("label_selfAssessment_staff_department_numberTable") }}
                </h4>
                <h2>
                  {{ $t("label_selfAssessment_staff_department_title") }}
                  <template-tooltip
                    tooltip="label_selfAssessment_staff_department_title_toolTip"
                  />
                </h2>
              </div>
              <div class="table">
                <div class="row table-header">
                  <div class="col-6 col-sm-8 col-md-8">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_staff_department_column_departments"
                        )
                      }}
                    </p>
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <p>
                      {{
                        $t("label_selfAssessment_staff_department_column_women")
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_staff_department_column_women_toolTip"
                      />
                    </p>
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <p>
                      {{
                        $t("label_selfAssessment_staff_department_column_men")
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_staff_department_column_men_toolTip"
                      />
                    </p>
                  </div>
                </div>
                <div class="row form-group self-assessment-table-column">
                  <div class="col-6 col-sm-8 col-md-8">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_staff_department_administration"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_staff_department_administration_tooltip"
                      />
                    </p>
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric
                      id="selfAssessment_staff_department_administration_women"
                      v-model="
                        selfAssessment_staff_department_administration_women
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_FIELDS_STAFF_BY_DEPARTMENT',
                          'women'
                        )
                      "
                    />
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric
                      id="selfAssessment_staff_department_administration_men"
                      v-model="
                        selfAssessment_staff_department_administration_men
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_FIELDS_STAFF_BY_DEPARTMENT',
                          'men'
                        )
                      "
                    />
                  </div>
                </div>
                <div class="row form-group self-assessment-table-column">
                  <div class="col-6 col-sm-8 col-md-8">
                    <p>
                      {{
                        $t("label_selfAssessment_staff_department_commercial")
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_staff_department_commercial_tooltip"
                      />
                    </p>
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric
                      id="selfAssessment_staff_department_commercial_women"
                      v-model="selfAssessment_staff_department_commercial_women"
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_FIELDS_STAFF_BY_DEPARTMENT',
                          'women'
                        )
                      "
                    />
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric
                      id="selfAssessment_staff_department_commercial_men"
                      v-model="selfAssessment_staff_department_commercial_men"
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_FIELDS_STAFF_BY_DEPARTMENT',
                          'men'
                        )
                      "
                    />
                  </div>
                </div>
                <div class="row form-group self-assessment-table-column">
                  <div class="col-6 col-sm-8 col-md-8">
                    <p>
                      {{
                        $t("label_selfAssessment_staff_department_logistics")
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_staff_department_logistics_tooltip"
                      />
                    </p>
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric
                      id="selfAssessment_staff_department_logistics_women"
                      v-model="selfAssessment_staff_department_logistics_women"
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_FIELDS_STAFF_BY_DEPARTMENT',
                          'women'
                        )
                      "
                    />
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric
                      id="selfAssessment_staff_department_logistics_men"
                      v-model="selfAssessment_staff_department_logistics_men"
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_FIELDS_STAFF_BY_DEPARTMENT',
                          'men'
                        )
                      "
                    />
                  </div>
                </div>
                <div class="row form-group self-assessment-table-column">
                  <div class="col-6 col-sm-8 col-md-8">
                    <p>
                      {{
                        $t("label_selfAssessment_staff_department_production")
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_staff_department_production_tooltip"
                      />
                    </p>
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric
                      id="selfAssessment_staff_department_production_women"
                      v-model="selfAssessment_staff_department_production_women"
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_FIELDS_STAFF_BY_DEPARTMENT',
                          'women'
                        )
                      "
                    />
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric
                      id="selfAssessment_staff_department_production_men"
                      v-model="selfAssessment_staff_department_production_men"
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_FIELDS_STAFF_BY_DEPARTMENT',
                          'men'
                        )
                      "
                    />
                  </div>
                </div>
                <div class="row form-group self-assessment-table-column">
                  <div class="col-6 col-sm-8 col-md-8">
                    <p>
                      {{ $t("label_selfAssessment_staff_department_service") }}
                      <template-tooltip
                        tooltip="label_selfAssessment_staff_department_service_tooltip"
                      />
                    </p>
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric
                      id="selfAssessment_staff_department_service_women"
                      v-model="selfAssessment_staff_department_service_women"
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_FIELDS_STAFF_BY_DEPARTMENT',
                          'women'
                        )
                      "
                    />
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric
                      id="selfAssessment_staff_department_service_men"
                      v-model="selfAssessment_staff_department_service_men"
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_FIELDS_STAFF_BY_DEPARTMENT',
                          'men'
                        )
                      "
                    />
                  </div>
                </div>
                <div class="row form-group self-assessment-table-column">
                  <div class="col-6 col-sm-8 col-md-8">
                    <p>
                      {{
                        $t("label_selfAssessment_staff_department_technical")
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_staff_department_technical_tooltip"
                      />
                    </p>
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric
                      id="selfAssessment_staff_department_technical_women"
                      v-model="selfAssessment_staff_department_technical_women"
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_FIELDS_STAFF_BY_DEPARTMENT',
                          'women'
                        )
                      "
                    />
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric
                      id="selfAssessment_staff_department_technical_men"
                      v-model="selfAssessment_staff_department_technical_men"
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_FIELDS_STAFF_BY_DEPARTMENT',
                          'men'
                        )
                      "
                    />
                  </div>
                </div>
                <div class="row form-group self-assessment-table-column">
                  <div class="col-6 col-sm-8 col-md-8">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_staff_department_humanResources"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_staff_department_humanResources_tooltip"
                      />
                    </p>
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric
                      id="selfAssessment_staff_department_humanResources_women"
                      v-model="
                        selfAssessment_staff_department_humanResources_women
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_FIELDS_STAFF_BY_DEPARTMENT',
                          'women'
                        )
                      "
                    />
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric
                      id="selfAssessment_staff_department_humanResources_men"
                      v-model="
                        selfAssessment_staff_department_humanResources_men
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_FIELDS_STAFF_BY_DEPARTMENT',
                          'men'
                        )
                      "
                    />
                  </div>
                </div>
                <!--Total Staff-->
                <div class="row form-group subtotal">
                  <div class="col-6 col-sm-8 col-md-8">
                    <p>
                      {{ $t("label_selfAssessment_staff_department_total") }}
                      <template-tooltip
                        tooltip="label_selfAssessment_staff_department_total_toolTip"
                      />
                    </p>
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric
                      v-model="selfAssessment_staff_department_total_women"
                      readonly
                    />
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric
                      v-model="selfAssessment_staff_department_total_men"
                      readonly
                    />
                  </div>
                </div>
                <!--END-->
                <!--Coincides-->
                <div>
                  <div>
                    <div class="row form-group subtotal">
                      <div class="col-6 col-sm-8 col-md-8">
                        <p>
                          {{
                            $t(
                              "label_selfAssessment_staff_department_coincidesWithTable1"
                            )
                          }}
                          <template-tooltip
                            tooltip="label_selfAssessment_staff_department_coincidesWithTable1_toolTip"
                          />
                        </p>
                      </div>
                      <div
                        v-if="
                          coincidesWithTable1Women(
                            selfAssessment_staff_department_total_women
                          )
                        "
                        class="col col-sm-2 col-md-2"
                      >
                        <p style="color: #43a39c; text-align: center">
                          {{ $t("label_selfAssessment_yes") }}
                        </p>
                      </div>
                      <div v-else class="col col-sm-2 col-md-2">
                        <p style="color: #a62122; text-align: center">
                          {{ $t("label_selfAssessment_no") }}
                        </p>
                      </div>
                      <div
                        v-if="
                          coincidesWithTable1Men(
                            selfAssessment_staff_department_total_men
                          )
                        "
                        class="col col-sm-2 col-md-2"
                      >
                        <p style="color: #43a39c; text-align: center">
                          {{ $t("label_selfAssessment_yes") }}
                        </p>
                      </div>
                      <div v-else class="col col-sm-2 col-md-2">
                        <p style="color: #a62122; text-align: center">
                          {{ $t("label_selfAssessment_no") }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <!--End Coincides-->
                <!--Differente-->
                <div>
                  <div
                    v-if="
                      coincidesWithTable1Women(
                        selfAssessment_staff_department_total_women
                      ) === false ||
                      coincidesWithTable1Men(
                        selfAssessment_staff_department_total_men
                      ) === false
                    "
                    class="row form-group subtotal"
                  >
                    <div class="col-6 col-sm-8 col-md-8">
                      <p>
                        {{
                          $t(
                            "label_selfAssessment_staff_department_differenceTable1"
                          )
                        }}
                        <template-tooltip
                          tooltip="label_selfAssessment_staff_department_coincidesWithTable1_toolTip"
                        />
                      </p>
                    </div>
                    <div
                      v-if="
                        coincidesWithTable1Women(
                          selfAssessment_staff_department_total_women
                        ) === false
                      "
                      class="col col-sm-2 col-md-2"
                    >
                      <form-input-numeric
                        style="background: #ddb9b9; color: white"
                        :value="
                          differenceWithTable1Women(
                            selfAssessment_staff_department_total_women
                          )
                        "
                        readonly
                      />
                    </div>
                    <div
                      v-if="
                        !coincidesWithTable1Women(
                          selfAssessment_staff_department_total_women
                        ) === false &&
                        coincidesWithTable1Men(
                          selfAssessment_staff_department_total_men
                        ) === false
                      "
                      class="col col-sm-2 col-md-2"
                    />
                    <div
                      v-if="
                        coincidesWithTable1Men(
                          selfAssessment_staff_department_total_men
                        ) === false
                      "
                      class="col col-sm-2 col-md-2"
                    >
                      <form-input-numeric
                        style="background: #ddb9b9; color: white"
                        :value="
                          differenceWithTable1Men(
                            selfAssessment_staff_department_total_men
                          )
                        "
                        readonly
                      />
                    </div>
                  </div>
                </div>
                <!--End Differente-->
              </div>
            </fieldset>
            <!--END-->
            <!--Table No 3 BOARD OF DIRECTORS-->
            <fieldset>
              <div class="header">
                <template-status :status="status.assessment" />
                <div class="icon">
                  <img
                    src="/static/icons/SelfAssessment-Icons/staff_board_icon.svg"
                    alt="algo"
                  />
                </div>
                <h4>
                  {{ $t("label_selfAssessment_staff_board_numberTable") }}
                </h4>
                <h2>
                  {{ $t("label_selfAssessment_staff_board_title") }}
                  <template-tooltip
                    tooltip="label_selfAssessment_staff_board_title_toolTip"
                  />
                </h2>
              </div>
              <div class="table">
                <div class="row table-header">
                  <div class="col-6 col-sm-8 col-md-8">
                    <p>
                      {{
                        $t("label_selfAssessment_staff_board_column_members")
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_staff_board_column_members_toolTip"
                      />
                    </p>
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_staff_byDemographics_column_women"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_staff_board_column_women_toolTip"
                      />
                    </p>
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <p>
                      {{ $t("label_selfAssessment_staff_board_column_men") }}
                      <template-tooltip
                        tooltip="label_selfAssessment_staff_board_column_men_toolTip"
                      />
                    </p>
                  </div>
                </div>
                <div class="row form-group">
                  <div class="col-6 col-sm-8 col-md-8">
                    <p>
                      {{ $t("label_selfAssessment_staff_board") }}
                      <template-tooltip
                        tooltip="label_selfAssessment_staff_board_tooltip"
                      />
                    </p>
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric
                      id="selfAssessment_staff_board_women"
                      v-model="selfAssessment_staff_board_women"
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_FIELDS_STAFF_BOARD_OF_DIRECTORS',
                          'women'
                        )
                      "
                    />
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric
                      id="selfAssessment_staff_board_men"
                      v-model="selfAssessment_staff_board_men"
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_FIELDS_STAFF_BOARD_OF_DIRECTORS',
                          'men'
                        )
                      "
                    />
                  </div>
                </div>
              </div>
            </fieldset>
            <!--END-->
            <!--Tabla No 4 STAFF DISTRIBUTION BY DEMOGRAPHICS-->
            <fieldset>
              <div class="header">
                <template-status :status="status.assessment" />
                <div class="icon">
                  <img
                    src="/static/icons/SelfAssessment-Icons/staff_demographics_icon.svg"
                    alt="demographics"
                    title="demographics"
                  />
                </div>
                <h4>
                  {{
                    $t("label_selfAssessment_staff_byDemographics_numberTable")
                  }}
                  <template-tooltip
                    tooltip="label_selfAssessment_staff_byDemographics_title_toolTip"
                  />
                </h4>
                <h2>
                  {{ $t("label_selfAssessment_staff_byDemographics_title") }}
                  <template-tooltip
                    tooltip="label_selfAssessment_staff_byDemographics_title_toolTip"
                  />
                </h2>
              </div>
              <!--Age-->
              <div class="label">
                {{
                  $t("label_selfAssessment_staff_byDemographics_age_category")
                }}
              </div>
              <div class="table">
                <div class="row table-header">
                  <div class="col-6 col-sm-8 col-md-8" />
                  <div class="col col-sm-2 col-md-2">
                    <p>
                      {{ $t("label_selfAssessment_staff_board_column_women") }}
                    </p>
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_staff_byDemographics_column_men"
                        )
                      }}
                    </p>
                  </div>
                </div>
                <div class="row form-group self-assessment-table-column">
                  <div class="col-6 col-sm-8 col-md-8">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_staff_byDemographics_age_under18"
                        )
                      }}
                    </p>
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric
                      id="selfAssessment_staff_byDemographics_age_under18_women"
                      v-model="
                        selfAssessment_staff_byDemographics_age_under18_women
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_FIELDS_BY_DEMOGRAPHICS_AGE',
                          'women'
                        )
                      "
                    />
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric
                      id="selfAssessment_staff_byDemographics_age_under18_men"
                      v-model="
                        selfAssessment_staff_byDemographics_age_under18_men
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_FIELDS_BY_DEMOGRAPHICS_AGE',
                          'men'
                        )
                      "
                    />
                  </div>
                </div>
                <div class="row form-group self-assessment-table-column">
                  <div class="col-6 col-sm-8 col-md-8">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_staff_byDemographics_age_between18And30"
                        )
                      }}
                    </p>
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric
                      id="selfAssessment_staff_byDemographics_age_between18And30_women"
                      v-model="
                        selfAssessment_staff_byDemographics_age_between18And30_women
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_FIELDS_BY_DEMOGRAPHICS_AGE',
                          'women'
                        )
                      "
                    />
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric
                      id="selfAssessment_staff_byDemographics_age_between18And30_men"
                      v-model="
                        selfAssessment_staff_byDemographics_age_between18And30_men
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_FIELDS_BY_DEMOGRAPHICS_AGE',
                          'men'
                        )
                      "
                    />
                  </div>
                </div>
                <div class="row form-group self-assessment-table-column">
                  <div class="col-6 col-sm-8 col-md-8">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_staff_byDemographics_age_between31And60"
                        )
                      }}
                    </p>
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric
                      id="selfAssessment_staff_byDemographics_age_between31And60_women"
                      v-model="
                        selfAssessment_staff_byDemographics_age_between31And60_women
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_FIELDS_BY_DEMOGRAPHICS_AGE',
                          'women'
                        )
                      "
                    />
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric
                      id="selfAssessment_staff_byDemographics_age_between31And60_men"
                      v-model="
                        selfAssessment_staff_byDemographics_age_between31And60_men
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_FIELDS_BY_DEMOGRAPHICS_AGE',
                          'men'
                        )
                      "
                    />
                  </div>
                </div>
                <div class="row form-group self-assessment-table-column">
                  <div class="col-6 col-sm-8 col-md-8">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_staff_byDemographics_age_older60"
                        )
                      }}
                    </p>
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric
                      id="selfAssessment_staff_byDemographics_age_older60_women"
                      v-model="
                        selfAssessment_staff_byDemographics_age_older60_women
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_FIELDS_BY_DEMOGRAPHICS_AGE',
                          'women'
                        )
                      "
                    />
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric
                      id="selfAssessment_staff_byDemographics_age_older60_men"
                      v-model="
                        selfAssessment_staff_byDemographics_age_older60_men
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_FIELDS_BY_DEMOGRAPHICS_AGE',
                          'men'
                        )
                      "
                    />
                  </div>
                </div>
                <!--Total Age-->
                <div class="row form-group subtotal">
                  <div class="col-6 col-sm-8 col-md-8">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_staff_byDemographics_age_total"
                        )
                      }}
                    </p>
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric v-model="totalAgeWomen" readonly />
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric :value="totalAgeMen" readonly />
                  </div>
                </div>
                <!--END-->
                <!--Coincides-->
                <div>
                  <div>
                    <div class="row form-group subtotal">
                      <div class="col-6 col-sm-8 col-md-8">
                        <p>
                          {{
                            $t(
                              "label_selfAssessment_staff_department_coincidesWithTable1"
                            )
                          }}
                          <template-tooltip
                            tooltip="label_selfAssessment_staff_department_coincidesWithTable1_toolTip"
                          />
                        </p>
                      </div>
                      <div
                        v-if="coincidesWithTable1Women(totalAgeWomen)"
                        class="col col-sm-2 col-md-2"
                      >
                        <p style="color: #43a39c; text-align: center">
                          {{ $t("label_selfAssessment_yes") }}
                        </p>
                      </div>
                      <div v-else class="col col-sm-2 col-md-2">
                        <p style="color: #a62122; text-align: center">
                          {{ $t("label_selfAssessment_no") }}
                        </p>
                      </div>
                      <div
                        v-if="coincidesWithTable1Men(totalAgeMen)"
                        class="col col-sm-2 col-md-2"
                      >
                        <p style="color: #43a39c; text-align: center">
                          {{ $t("label_selfAssessment_yes") }}
                        </p>
                      </div>
                      <div v-else class="col col-sm-2 col-md-2">
                        <p style="color: #a62122; text-align: center">
                          {{ $t("label_selfAssessment_no") }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <!--End Coincides-->
                <!--Differente-->
                <div>
                  <div
                    v-if="
                      coincidesWithTable1Women(totalAgeWomen) === false ||
                      coincidesWithTable1Men(totalAgeMen) === false
                    "
                    class="row form-group subtotal"
                  >
                    <div class="col-6 col-sm-8 col-md-8">
                      <p>
                        {{
                          $t(
                            "label_selfAssessment_staff_department_differenceTable1"
                          )
                        }}
                        <template-tooltip
                          tooltip="label_selfAssessment_staff_department_coincidesWithTable1_toolTip"
                        />
                      </p>
                    </div>
                    <div
                      v-if="coincidesWithTable1Women(totalAgeWomen) === false"
                      class="col col-sm-2 col-md-2"
                    >
                      <form-input-numeric
                        style="background: #ddb9b9; color: white"
                        :value="differenceWithTable1Women(totalAgeWomen)"
                        readonly
                      />
                    </div>
                    <div
                      v-if="
                        !coincidesWithTable1Women(totalAgeWomen) === false &&
                        coincidesWithTable1Men(totalAgeMen) === false
                      "
                      class="col col-sm-2 col-md-2"
                    />
                    <div
                      v-if="coincidesWithTable1Men(totalAgeMen) === false"
                      class="col col-sm-2 col-md-2"
                    >
                      <form-input-numeric
                        style="background: #ddb9b9; color: white"
                        :value="differenceWithTable1Men(totalAgeMen)"
                        readonly
                      />
                    </div>
                  </div>
                </div>
                <!--End Differente-->
              </div>
              <!--End-->
              <!--Disabilities-->
              <div class="label">
                {{
                  $t(
                    "label_selfAssessment_staff_byDemographics_disabilities_category"
                  )
                }}
                <template-tooltip
                  tooltip="label_selfAssessment_staff_byDemographics_disabilities_category_toolTip"
                />
              </div>
              <div class="table">
                <div class="row form-group self-assessment-table-column">
                  <div class="col-6 col-sm-8 col-md-8">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_staff_byDemographics_disability_yes"
                        )
                      }}
                    </p>
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric
                      id="selfAssessment_staff_byDemographics_disability_yes_women"
                      v-model="
                        selfAssessment_staff_byDemographics_disability_yes_women
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_FIELDS_BY_DEMOGRAPHIC_DISABILITIES',
                          'women'
                        )
                      "
                    />
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric
                      id="selfAssessment_staff_byDemographics_disability_yes_men"
                      v-model="
                        selfAssessment_staff_byDemographics_disability_yes_men
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_FIELDS_BY_DEMOGRAPHIC_DISABILITIES',
                          'men'
                        )
                      "
                    />
                  </div>
                </div>
                <div class="row form-group self-assessment-table-column">
                  <div class="col-6 col-sm-8 col-md-8">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_staff_byDemographics_disability_no"
                        )
                      }}
                      <template-tooltip
                        tooltip="label_selfAssessment_staff_department_humanResources_tooltip"
                      />
                    </p>
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric
                      id="selfAssessment_staff_byDemographics_disability_no_women"
                      v-model="
                        selfAssessment_staff_byDemographics_disability_no_women
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_FIELDS_BY_DEMOGRAPHIC_DISABILITIES',
                          'women'
                        )
                      "
                    />
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric
                      id="selfAssessment_staff_byDemographics_disability_no_men"
                      v-model="
                        selfAssessment_staff_byDemographics_disability_no_men
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_FIELDS_BY_DEMOGRAPHIC_DISABILITIES',
                          'men'
                        )
                      "
                    />
                  </div>
                </div>
                <!--Total-->
                <div class="row form-group subtotal">
                  <div class="col-6 col-sm-8 col-md-8">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_staff_byDemographics_disability_total"
                        )
                      }}
                    </p>
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric
                      :value="totalDesabilitiesWomen"
                      readonly
                    />
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric
                      :value="totalDesabilitiesMen"
                      readonly
                    />
                  </div>
                </div>
                <!--END-->
                <!--Coincides-->
                <div>
                  <div>
                    <div class="row form-group subtotal">
                      <div class="col-6 col-sm-8 col-md-8">
                        <p>
                          {{
                            $t(
                              "label_selfAssessment_staff_department_coincidesWithTable1"
                            )
                          }}
                          <template-tooltip
                            tooltip="label_selfAssessment_staff_department_coincidesWithTable1_toolTip"
                          />
                        </p>
                      </div>
                      <div
                        v-if="coincidesWithTable1Women(totalDesabilitiesWomen)"
                        class="col col-sm-2 col-md-2"
                      >
                        <p style="color: #43a39c; text-align: center">
                          {{ $t("label_selfAssessment_yes") }}
                        </p>
                      </div>
                      <div v-else class="col col-sm-2 col-md-2">
                        <p style="color: #a62122; text-align: center">
                          {{ $t("label_selfAssessment_no") }}
                        </p>
                      </div>
                      <div
                        v-if="coincidesWithTable1Men(totalDesabilitiesMen)"
                        class="col col-sm-2 col-md-2"
                      >
                        <p style="color: #43a39c; text-align: center">
                          {{ $t("label_selfAssessment_yes") }}
                        </p>
                      </div>
                      <div v-else class="col col-sm-2 col-md-2">
                        <p style="color: #a62122; text-align: center">
                          {{ $t("label_selfAssessment_no") }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <!--End Coincides-->
                <!--Differente-->
                <div>
                  <div
                    v-if="
                      coincidesWithTable1Women(totalDesabilitiesWomen) ===
                        false ||
                      coincidesWithTable1Men(totalDesabilitiesMen) === false
                    "
                    class="row form-group subtotal"
                  >
                    <div class="col-6 col-sm-8 col-md-8">
                      <p>
                        {{
                          $t(
                            "label_selfAssessment_staff_department_differenceTable1"
                          )
                        }}
                        <template-tooltip
                          tooltip="label_selfAssessment_staff_department_coincidesWithTable1_toolTip"
                        />
                      </p>
                    </div>
                    <div
                      v-if="
                        coincidesWithTable1Women(totalDesabilitiesWomen) ===
                        false
                      "
                      class="col col-sm-2 col-md-2"
                    >
                      <form-input-numeric
                        style="background: #ddb9b9; color: white"
                        :value="
                          differenceWithTable1Women(totalDesabilitiesWomen)
                        "
                        readonly
                      />
                    </div>
                    <div
                      v-if="
                        !coincidesWithTable1Women(totalDesabilitiesWomen) ===
                          false &&
                        coincidesWithTable1Men(totalDesabilitiesMen) === false
                      "
                      class="col col-sm-2 col-md-2"
                    />
                    <div
                      v-if="
                        coincidesWithTable1Men(totalDesabilitiesMen) === false
                      "
                      class="col col-sm-2 col-md-2"
                    >
                      <form-input-numeric
                        style="background: #ddb9b9; color: white"
                        :value="differenceWithTable1Men(totalDesabilitiesMen)"
                        readonly
                      />
                    </div>
                  </div>
                </div>
                <!--End Differente-->
              </div>
              <!--End-->

              <!--Ethnic Identity-->
              <div class="label">
                {{
                  $t(
                    "label_selfAssessment_staff_byDemographics_ethnicIdentity_category"
                  )
                }}
                <template-tooltip
                  tooltip="label_selfAssessment_staff_byDemographics_ethnicIdentity_category_toolTip"
                />
              </div>
              <div class="table">
                <div class="row form-group self-assessment-table-column">
                  <div class="col-6 col-sm-8 col-md-8">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_staff_byDemographics_ethnicIdentity_afrodescendant"
                        )
                      }}
                    </p>
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric
                      id="selfAssessment_staff_byDemographics_ethnicIdentity_afrodescendant_women"
                      v-model="
                        selfAssessment_staff_byDemographics_ethnicIdentity_afrodescendant_women
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_FIELDS_BY_ETHNIC_IDENTITY',
                          'women'
                        )
                      "
                    />
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric
                      id="selfAssessment_staff_byDemographics_ethnicIdentity_afrodescendant_men"
                      v-model="
                        selfAssessment_staff_byDemographics_ethnicIdentity_afrodescendant_men
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_FIELDS_BY_ETHNIC_IDENTITY',
                          'men'
                        )
                      "
                    />
                  </div>
                </div>
                <!--Asian -->
                <div class="row form-group self-assessment-table-column">
                  <div class="col-6 col-sm-8 col-md-8">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_staff_byDemographics_ethnicIdentity_asian"
                        )
                      }}
                    </p>
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric
                      id="selfAssessment_staff_byDemographics_ethnicIdentity_asian_women"
                      v-model="
                        selfAssessment_staff_byDemographics_ethnicIdentity_asian_women
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_FIELDS_BY_ETHNIC_IDENTITY',
                          'women'
                        )
                      "
                    />
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric
                      id="selfAssessment_staff_byDemographics_ethnicIdentity_asian_men"
                      v-model="
                        selfAssessment_staff_byDemographics_ethnicIdentity_asian_men
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_FIELDS_BY_ETHNIC_IDENTITY',
                          'men'
                        )
                      "
                    />
                  </div>
                </div>

                <!-- Hispanic -->
                <div class="row form-group self-assessment-table-column">
                  <div class="col-6 col-sm-8 col-md-8">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_staff_byDemographics_ethnicIdentity_hispanic"
                        )
                      }}
                    </p>
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric
                      id="selfAssessment_staff_byDemographics_ethnicIdentity_hispanic_women"
                      v-model="
                        selfAssessment_staff_byDemographics_ethnicIdentity_hispanic_women
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_FIELDS_BY_ETHNIC_IDENTITY',
                          'women'
                        )
                      "
                    />
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric
                      id="selfAssessment_staff_byDemographics_ethnicIdentity_hispanic_men"
                      v-model="
                        selfAssessment_staff_byDemographics_ethnicIdentity_hispanic_men
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_FIELDS_BY_ETHNIC_IDENTITY',
                          'men'
                        )
                      "
                    />
                  </div>
                </div>

                <div class="row form-group self-assessment-table-column">
                  <div class="col-6 col-sm-8 col-md-8">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_staff_byDemographics_ethnicIdentity_indigenous"
                        )
                      }}
                    </p>
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric
                      id="selfAssessment_staff_byDemographics_ethnicIdentity_indigenous_women"
                      v-model="
                        selfAssessment_staff_byDemographics_ethnicIdentity_indigenous_women
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_FIELDS_BY_ETHNIC_IDENTITY',
                          'women'
                        )
                      "
                    />
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric
                      id="selfAssessment_staff_byDemographics_ethnicIdentity_indigenous_men"
                      v-model="
                        selfAssessment_staff_byDemographics_ethnicIdentity_indigenous_men
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_FIELDS_BY_ETHNIC_IDENTITY',
                          'men'
                        )
                      "
                    />
                  </div>
                </div>
                <!-- Other Etnic Groups-->

                <div class="row form-group self-assessment-table-column">
                  <div class="col-6 col-sm-8 col-md-8">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_staff_byDemographics_ethnicIdentity_other"
                        )
                      }}
                    </p>
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric
                      id="selfAssessment_staff_byDemographics_ethnicIdentity_other_women"
                      v-model="
                        selfAssessment_staff_byDemographics_ethnicIdentity_other_women
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_FIELDS_BY_ETHNIC_IDENTITY',
                          'women'
                        )
                      "
                    />
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric
                      id="selfAssessment_staff_byDemographics_ethnicIdentity_other_men"
                      v-model="
                        selfAssessment_staff_byDemographics_ethnicIdentity_other_men
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_FIELDS_BY_ETHNIC_IDENTITY',
                          'men'
                        )
                      "
                    />
                  </div>
                </div>
                <!--Other Custom 1-->
                <div class="row form-group">
                  <div class="col-6 col-sm-8 col-md-8">
                    <b-form-input
                      id="selfAssessment_staff_byDemographics_ethnicIdentity_otherCustom1"
                      v-model="
                        selfAssessment_staff_byDemographics_ethnicIdentity_otherCustom1
                      "
                      class="other-custom-ethnic-identity"
                      :placeholder="
                        $t(
                          'label_selfAssessment_staff_byDemographics_ethnicIdentity_otherCustom'
                        )
                      "
                      :disabled="!canUpdateSelfAssessment"
                      @change.native="updateSelfAssessmentTextInput"
                    />
                  </div>
                </div>

                <!-- Other Custom 2 -->
                <div class="row form-group">
                  <div class="col-6 col-sm-8 col-md-8">
                    <b-form-input
                      id="selfAssessment_staff_byDemographics_ethnicIdentity_otherCustom2"
                      v-model="
                        selfAssessment_staff_byDemographics_ethnicIdentity_otherCustom2
                      "
                      class="other-custom-ethnic-identity"
                      :placeholder="
                        $t(
                          'label_selfAssessment_staff_byDemographics_ethnicIdentity_otherCustom'
                        )
                      "
                      :disabled="!canUpdateSelfAssessment"
                      @change.native="updateSelfAssessmentTextInput"
                    />
                  </div>
                </div>

                <!-- Other Custom 3 -->
                <div class="row form-group">
                  <div class="col-6 col-sm-8 col-md-8">
                    <b-form-input
                      id="selfAssessment_staff_byDemographics_ethnicIdentity_otherCustom3"
                      v-model="
                        selfAssessment_staff_byDemographics_ethnicIdentity_otherCustom3
                      "
                      class="other-custom-ethnic-identity"
                      :placeholder="
                        $t(
                          'label_selfAssessment_staff_byDemographics_ethnicIdentity_otherCustom'
                        )
                      "
                      :disabled="!canUpdateSelfAssessment"
                      @change.native="updateSelfAssessmentTextInput"
                    />
                  </div>
                </div>

                <!-- Other Custom 4 -->
                <div class="row form-group">
                  <div class="col-6 col-sm-8 col-md-8">
                    <b-form-input
                      id="selfAssessment_staff_byDemographics_ethnicIdentity_otherCustom4"
                      v-model="
                        selfAssessment_staff_byDemographics_ethnicIdentity_otherCustom4
                      "
                      class="other-custom-ethnic-identity"
                      :placeholder="
                        $t(
                          'label_selfAssessment_staff_byDemographics_ethnicIdentity_otherCustom'
                        )
                      "
                      :disabled="!canUpdateSelfAssessment"
                      @change.native="updateSelfAssessmentTextInput"
                    />
                  </div>
                </div>

                <!--Total-->
                <div class="row form-group subtotal">
                  <div class="col-6 col-sm-8 col-md-8">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_staff_byDemographics_ethnicIdentity_total"
                        )
                      }}
                    </p>
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric :value="totalIdentityWomen" readonly />
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric :value="totalIdentityMen" readonly />
                  </div>
                </div>
                <!--END-->
                <!--Coincides-->
                <div>
                  <div>
                    <div class="row form-group subtotal">
                      <div class="col-6 col-sm-8 col-md-8">
                        <p>
                          {{
                            $t(
                              "label_selfAssessment_staff_department_coincidesWithTable1"
                            )
                          }}
                          <template-tooltip
                            tooltip="label_selfAssessment_staff_department_coincidesWithTable1_toolTip"
                          />
                        </p>
                      </div>
                      <div
                        v-if="coincidesWithTable1Women(totalIdentityWomen)"
                        class="col col-sm-2 col-md-2"
                      >
                        <p style="color: #43a39c; text-align: center">
                          {{ $t("label_selfAssessment_yes") }}
                        </p>
                      </div>
                      <div v-else class="col col-sm-2 col-md-2">
                        <p style="color: #a62122; text-align: center">
                          {{ $t("label_selfAssessment_no") }}
                        </p>
                      </div>
                      <div
                        v-if="coincidesWithTable1Men(totalIdentityMen)"
                        class="col col-sm-2 col-md-2"
                      >
                        <p style="color: #43a39c; text-align: center">
                          {{ $t("label_selfAssessment_yes") }}
                        </p>
                      </div>
                      <div v-else class="col col-sm-2 col-md-2">
                        <p style="color: #a62122; text-align: center">
                          {{ $t("label_selfAssessment_no") }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <!--End Coincides-->
                <!--Differente-->
                <div>
                  <div
                    v-if="
                      coincidesWithTable1Women(totalIdentityWomen) === false ||
                      coincidesWithTable1Men(totalIdentityMen) === false
                    "
                    class="row form-group subtotal"
                  >
                    <div class="col-6 col-sm-8 col-md-8">
                      <p>
                        {{
                          $t(
                            "label_selfAssessment_staff_department_differenceTable1"
                          )
                        }}
                        <template-tooltip
                          tooltip="label_selfAssessment_staff_department_coincidesWithTable1_toolTip"
                        />
                      </p>
                    </div>
                    <div
                      v-if="
                        coincidesWithTable1Women(totalIdentityWomen) === false
                      "
                      class="col col-sm-2 col-md-2"
                    >
                      <form-input-numeric
                        style="background: #ddb9b9; color: white"
                        :value="differenceWithTable1Women(totalIdentityWomen)"
                        readonly
                      />
                    </div>
                    <div
                      v-if="
                        !coincidesWithTable1Women(totalIdentityWomen) ===
                          false &&
                        coincidesWithTable1Men(totalIdentityMen) === false
                      "
                      class="col col-sm-2 col-md-2"
                    />
                    <div
                      v-if="coincidesWithTable1Men(totalIdentityMen) === false"
                      class="col col-sm-2 col-md-2"
                    >
                      <form-input-numeric
                        style="background: #ddb9b9; color: white"
                        :value="differenceWithTable1Men(totalIdentityMen)"
                        readonly
                      />
                    </div>
                  </div>
                </div>
                <!--End Differente-->
              </div>
              <!--End-->

              <!--Seniority-->
              <div class="label">
                {{
                  $t(
                    "label_selfAssessment_staff_byDemographics_seniority_category"
                  )
                }}
                <template-tooltip
                  tooltip="label_selfAssessment_staff_byDemographics_seniority_category_toolTip"
                />
              </div>
              <div class="table">
                <div class="row form-group self-assessment-table-column">
                  <div class="col-6 col-sm-8 col-md-8">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_staff_byDemographics_seniority_less2"
                        )
                      }}
                    </p>
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric
                      id="selfAssessment_staff_byDemographics_seniority_less2_women"
                      v-model="
                        selfAssessment_staff_byDemographics_seniority_less2_women
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_FIELDS_BY_ETHNIC_SENIORITY',
                          'women'
                        )
                      "
                    />
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric
                      id="selfAssessment_staff_byDemographics_seniority_less2_men"
                      v-model="
                        selfAssessment_staff_byDemographics_seniority_less2_men
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_FIELDS_BY_ETHNIC_SENIORITY',
                          'men'
                        )
                      "
                    />
                  </div>
                </div>
                <div class="row form-group self-assessment-table-column">
                  <div class="col-6 col-sm-8 col-md-8">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_staff_byDemographics_seniority_between2And5"
                        )
                      }}
                    </p>
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric
                      id="selfAssessment_staff_byDemographics_seniority_between2And5_women"
                      v-model="
                        selfAssessment_staff_byDemographics_seniority_between2And5_women
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_FIELDS_BY_ETHNIC_SENIORITY',
                          'women'
                        )
                      "
                    />
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric
                      id="selfAssessment_staff_byDemographics_seniority_between2And5_men"
                      v-model="
                        selfAssessment_staff_byDemographics_seniority_between2And5_men
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_FIELDS_BY_ETHNIC_SENIORITY',
                          'men'
                        )
                      "
                    />
                  </div>
                </div>
                <div class="row form-group self-assessment-table-column">
                  <div class="col-6 col-sm-8 col-md-8">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_staff_byDemographics_seniority_between5And10"
                        )
                      }}
                    </p>
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric
                      id="selfAssessment_staff_byDemographics_seniority_between5And10_women"
                      v-model="
                        selfAssessment_staff_byDemographics_seniority_between5And10_women
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_FIELDS_BY_ETHNIC_SENIORITY',
                          'women'
                        )
                      "
                    />
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric
                      id="selfAssessment_staff_byDemographics_seniority_between5And10_men"
                      v-model="
                        selfAssessment_staff_byDemographics_seniority_between5And10_men
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_FIELDS_BY_ETHNIC_SENIORITY',
                          'men'
                        )
                      "
                    />
                  </div>
                </div>
                <div class="row form-group self-assessment-table-column">
                  <div class="col-6 col-sm-8 col-md-8">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_staff_byDemographics_seniority_more10"
                        )
                      }}
                    </p>
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric
                      id="selfAssessment_staff_byDemographics_seniority_more10_women"
                      v-model="
                        selfAssessment_staff_byDemographics_seniority_more10_women
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_FIELDS_BY_ETHNIC_SENIORITY',
                          'women'
                        )
                      "
                    />
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric
                      id="selfAssessment_staff_byDemographics_seniority_more10_men"
                      v-model="
                        selfAssessment_staff_byDemographics_seniority_more10_men
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_FIELDS_BY_ETHNIC_SENIORITY',
                          'men'
                        )
                      "
                    />
                  </div>
                </div>
                <!--Total-->
                <div class="row form-group subtotal">
                  <div class="col-6 col-sm-8 col-md-8">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_staff_byDemographics_seniority_total"
                        )
                      }}
                    </p>
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric :value="totalSeniorityWomen" readonly />
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric :value="totalSeniorityMen" readonly />
                  </div>
                </div>
                <!--END-->
                <!--Coincides-->
                <div>
                  <div>
                    <div class="row form-group subtotal">
                      <div class="col-6 col-sm-8 col-md-8">
                        <p>
                          {{
                            $t(
                              "label_selfAssessment_staff_department_coincidesWithTable1"
                            )
                          }}
                          <template-tooltip
                            tooltip="label_selfAssessment_staff_department_coincidesWithTable1_toolTip"
                          />
                        </p>
                      </div>
                      <div
                        v-if="coincidesWithTable1Women(totalSeniorityWomen)"
                        class="col col-sm-2 col-md-2"
                      >
                        <p style="color: #43a39c; text-align: center">
                          {{ $t("label_selfAssessment_yes") }}
                        </p>
                      </div>
                      <div v-else class="col col-sm-2 col-md-2">
                        <p style="color: #a62122; text-align: center">
                          {{ $t("label_selfAssessment_no") }}
                        </p>
                      </div>
                      <div
                        v-if="coincidesWithTable1Men(totalSeniorityMen)"
                        class="col col-sm-2 col-md-2"
                      >
                        <p style="color: #43a39c; text-align: center">
                          {{ $t("label_selfAssessment_yes") }}
                        </p>
                      </div>
                      <div v-else class="col col-sm-2 col-md-2">
                        <p style="color: #a62122; text-align: center">
                          {{ $t("label_selfAssessment_no") }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <!--End Coincides-->
                <!--Differente-->
                <div>
                  <div
                    v-if="
                      coincidesWithTable1Women(totalSeniorityWomen) === false ||
                      coincidesWithTable1Men(totalSeniorityMen) === false
                    "
                    class="row form-group subtotal"
                  >
                    <div class="col-6 col-sm-8 col-md-8">
                      <p>
                        {{
                          $t(
                            "label_selfAssessment_staff_department_differenceTable1"
                          )
                        }}
                        <template-tooltip
                          tooltip="label_selfAssessment_staff_department_coincidesWithTable1_toolTip"
                        />
                      </p>
                    </div>
                    <div
                      v-if="
                        coincidesWithTable1Women(totalSeniorityWomen) === false
                      "
                      class="col col-sm-2 col-md-2"
                    >
                      <form-input-numeric
                        style="background: #ddb9b9; color: white"
                        :value="differenceWithTable1Women(totalSeniorityWomen)"
                        readonly
                      />
                    </div>
                    <div
                      v-if="
                        !coincidesWithTable1Women(totalSeniorityWomen) ===
                          false &&
                        coincidesWithTable1Men(totalSeniorityMen) === false
                      "
                      class="col col-sm-2 col-md-2"
                    />
                    <div
                      v-if="coincidesWithTable1Men(totalSeniorityMen) === false"
                      class="col col-sm-2 col-md-2"
                    >
                      <form-input-numeric
                        style="background: #ddb9b9; color: white"
                        :value="differenceWithTable1Men(totalSeniorityMen)"
                        readonly
                      />
                    </div>
                  </div>
                </div>
                <!--End Differente-->
              </div>
              <!--End-->

              <!--Gender Identity-->
              <div class="label">
                {{
                  $t(
                    "label_selfAssessment_staff_byDemographics_genderIdentity_category"
                  )
                }}
                <template-tooltip
                  tooltip="label_selfAssessment_staff_byDemographics_genderIdentity_category_toolTip"
                />
              </div>
              <div class="table">
                <div class="row form-group self-assessment-table-column">
                  <div class="col-6 col-sm-8 col-md-8">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_staff_byDemographics_genderIdentity_womenMen"
                        )
                      }}
                    </p>
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric
                      id="selfAssessment_staff_byDemographics_genderIdentity_womenMen_women"
                      v-model="
                        selfAssessment_staff_byDemographics_genderIdentity_womenMen_women
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_FIELDS_BY_GENDER_IDENTITY',
                          'women'
                        )
                      "
                    />
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric
                      id="selfAssessment_staff_byDemographics_genderIdentity_womenMen_men"
                      v-model="
                        selfAssessment_staff_byDemographics_genderIdentity_womenMen_men
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_FIELDS_BY_GENDER_IDENTITY',
                          'men'
                        )
                      "
                    />
                  </div>
                </div>

                <div class="row form-group self-assessment-table-column">
                  <div class="col-6 col-sm-8 col-md-8">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_staff_byDemographics_genderIdentity_transgenderMen"
                        )
                      }}
                    </p>
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric
                      id="selfAssessment_staff_byDemographics_genderIdentity_transgenderMen_women"
                      v-model="
                        selfAssessment_staff_byDemographics_genderIdentity_transgenderMen_women
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_FIELDS_BY_GENDER_IDENTITY',
                          'women'
                        )
                      "
                    />
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric
                      id="selfAssessment_staff_byDemographics_genderIdentity_transgenderMen_men"
                      v-model="
                        selfAssessment_staff_byDemographics_genderIdentity_transgenderMen_men
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_FIELDS_BY_GENDER_IDENTITY',
                          'men'
                        )
                      "
                    />
                  </div>
                </div>

                <div class="row form-group self-assessment-table-column">
                  <div class="col-6 col-sm-8 col-md-8">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_staff_byDemographics_genderIdentity_transgenderWomen"
                        )
                      }}
                    </p>
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric
                      id="selfAssessment_staff_byDemographics_genderIdentity_transgenderWomen_women"
                      v-model="
                        selfAssessment_staff_byDemographics_genderIdentity_transgenderWomen_women
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_FIELDS_BY_GENDER_IDENTITY',
                          'women'
                        )
                      "
                    />
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric
                      id="selfAssessment_staff_byDemographics_genderIdentity_transgenderWomen_men"
                      v-model="
                        selfAssessment_staff_byDemographics_genderIdentity_transgenderWomen_men
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_FIELDS_BY_GENDER_IDENTITY',
                          'men'
                        )
                      "
                    />
                  </div>
                </div>

                <div class="row form-group self-assessment-table-column">
                  <div class="col-6 col-sm-8 col-md-8">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_staff_byDemographics_genderIdentity_genderNonConforming"
                        )
                      }}
                    </p>
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric
                      id="selfAssessment_staff_byDemographics_genderIdentity_genderNonConforming_women"
                      v-model="
                        selfAssessment_staff_byDemographics_genderIdentity_genderNonConforming_women
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_FIELDS_BY_GENDER_IDENTITY',
                          'women'
                        )
                      "
                    />
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric
                      id="selfAssessment_staff_byDemographics_genderIdentity_genderNonConforming_men"
                      v-model="
                        selfAssessment_staff_byDemographics_genderIdentity_genderNonConforming_men
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_FIELDS_BY_GENDER_IDENTITY',
                          'men'
                        )
                      "
                    />
                  </div>
                </div>

                <div class="row form-group self-assessment-table-column">
                  <div class="col-6 col-sm-8 col-md-8">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_staff_byDemographics_genderIdentity_other"
                        )
                      }}
                    </p>
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric
                      id="selfAssessment_staff_byDemographics_genderIdentity_other_women"
                      v-model="
                        selfAssessment_staff_byDemographics_genderIdentity_other_women
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_FIELDS_BY_GENDER_IDENTITY',
                          'women'
                        )
                      "
                    />
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric
                      id="selfAssessment_staff_byDemographics_genderIdentity_other_men"
                      v-model="
                        selfAssessment_staff_byDemographics_genderIdentity_other_men
                      "
                      :disabled="!canUpdateSelfAssessment"
                      required
                      min="0"
                      @change.native="
                        updateByGenderSA(
                          $event,
                          'SELF_ASSESSMENT_FIELDS_BY_GENDER_IDENTITY',
                          'men'
                        )
                      "
                    />
                  </div>
                </div>
                <!--Revisar-->
                <div class="row form-group">
                  <div class="col-6 col-sm-8 col-md-8">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_staff_byDemographics_genderIdentity_other_description"
                        )
                      }}
                    </p>
                  </div>
                  <div class="col col-sm-4 col-md-4">
                    <b-form-input
                      id="selfAssessment_staff_byDemographics_genderIdentity_other_description"
                      v-model="
                        selfAssessment_staff_byDemographics_genderIdentity_other_description
                      "
                      :disabled="!canUpdateSelfAssessment"
                      @change.native="updateSelfAssessmentTextInput"
                    />
                  </div>
                </div>
                <!--End-->
                <!--Total-->
                <div class="row form-group subtotal">
                  <div class="col-6 col-sm-8 col-md-8">
                    <p>
                      {{
                        $t(
                          "label_selfAssessment_staff_byDemographics_genderIdentity_total"
                        )
                      }}
                    </p>
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric :value="totalGenderWomen" readonly />
                  </div>
                  <div class="col col-sm-2 col-md-2">
                    <form-input-numeric :value="totalGenderMen" readonly />
                  </div>
                </div>
                <!--END Total-->
                <!--Coincides-->
                <div>
                  <div>
                    <div class="row form-group subtotal">
                      <div class="col-6 col-sm-8 col-md-8">
                        <p>
                          {{
                            $t(
                              "label_selfAssessment_staff_department_coincidesWithTable1"
                            )
                          }}
                          <template-tooltip
                            tooltip="label_selfAssessment_staff_department_coincidesWithTable1_toolTip"
                          />
                        </p>
                      </div>
                      <div
                        v-if="coincidesWithTable1Women(totalGenderWomen)"
                        class="col col-sm-2 col-md-2"
                      >
                        <p style="color: #43a39c; text-align: center">
                          {{ $t("label_selfAssessment_yes") }}
                        </p>
                      </div>
                      <div v-else class="col col-sm-2 col-md-2">
                        <p style="color: #a62122; text-align: center">
                          {{ $t("label_selfAssessment_no") }}
                        </p>
                      </div>
                      <div
                        v-if="coincidesWithTable1Men(totalGenderMen)"
                        class="col col-sm-2 col-md-2"
                      >
                        <p style="color: #43a39c; text-align: center">
                          {{ $t("label_selfAssessment_yes") }}
                        </p>
                      </div>
                      <div v-else class="col col-sm-2 col-md-2">
                        <p style="color: #a62122; text-align: center">
                          {{ $t("label_selfAssessment_no") }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <!--End Coincides-->
                <!--Differente-->
                <div>
                  <div
                    v-if="
                      coincidesWithTable1Women(totalGenderWomen) === false ||
                      coincidesWithTable1Men(totalGenderMen) === false
                    "
                    class="row form-group subtotal"
                  >
                    <div class="col-6 col-sm-8 col-md-8">
                      <p>
                        {{
                          $t(
                            "label_selfAssessment_staff_department_differenceTable1"
                          )
                        }}
                        <template-tooltip
                          tooltip="label_selfAssessment_staff_department_coincidesWithTable1_toolTip"
                        />
                      </p>
                    </div>
                    <div
                      v-if="
                        coincidesWithTable1Women(totalGenderWomen) === false
                      "
                      class="col col-sm-2 col-md-2"
                    >
                      <form-input-numeric
                        style="background: #ddb9b9; color: white"
                        :value="differenceWithTable1Women(totalGenderWomen)"
                        readonly
                      />
                    </div>
                    <div
                      v-if="
                        !coincidesWithTable1Women(totalGenderWomen) === false &&
                        coincidesWithTable1Men(totalGenderMen) === false
                      "
                      class="col col-sm-2 col-md-2"
                    />
                    <div
                      v-if="coincidesWithTable1Men(totalGenderMen) === false"
                      class="col col-sm-2 col-md-2"
                    >
                      <form-input-numeric
                        style="background: #ddb9b9; color: white"
                        :value="differenceWithTable1Men(totalGenderMen)"
                        readonly
                      />
                    </div>
                  </div>
                </div>
                <!--End Differente-->
              </div>
              <!--End-->
            </fieldset>
            <!--END-->
          </b-form>
        </b-col>
      </b-row>
      <b-row align-h="center">
        <b-col lg="3">
          <b-button
            style="margin: 20px 0"
            variant="primary"
            to="/self-assessment/labor-conditions"
            block
          >
            {{ $t("label_selfAssessment_button_continue") }}
          </b-button>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import { createHelpers } from "vuex-map-fields";
import { mapGetters, mapMutations } from "vuex";
import {
  SELF_ASSESSMENT_FIELDS_STAFF_RESPONSABILITY_LEADERSHIP,
  SELF_ASSESSMENT_FIELDS_STAFF_RESPONSABILITY_OTHER_POSITIONS,
} from "../../../constants/selfAssessmentStaff.constants";

const { mapFields } = createHelpers({
  getterType: "getSelfAssessmentField",
  mutationType: "updateSelfAssessmentField",
});

export default {
  name: "SelfAssessmentStaff",

  created: async function () {
    await this.$store.dispatch("SNAPSHOTS_GET");
    await this.$store.dispatch("BUSINESS_GET");
    this.$store
      .dispatch("SELF_ASSESSMENT_GET")
      .then(() => {
        this.$store.commit("setReloadSelfAssessment", false);
      })
      .catch((err) => {
        console.log(err);
        this.$router.push("/home"); // TODO Handle the error in a better way
      });
  },

  methods: {
    coincidesWithTable1Women: function (totalToCompareWomen) {
      if (
        this.selfAssessment_staff_responsibility_total_women ===
        totalToCompareWomen
      ) {
        return true;
      } else {
        return false;
      }
    },
    coincidesWithTable1Men: function (totalToCompareMen) {
      if (
        this.selfAssessment_staff_responsibility_total_men === totalToCompareMen
      ) {
        return true;
      } else {
        return false;
      }
    },
    differenceWithTable1Women: function (totalToCompareWomen) {
      return (
        this.selfAssessment_staff_responsibility_total_women -
        totalToCompareWomen
      );
    },
    differenceWithTable1Men: function (totalToCompareMen) {
      return (
        this.selfAssessment_staff_responsibility_total_men - totalToCompareMen
      );
    },
    updateSelfAssessmentTextInput: function (event) {
      var data = {};
      data[event.target.id] = event.target.value;
      this.$store.dispatch("SELF_ASSESSMENT_UPDATE", data);
    },
    updateSelfAssessment: function (event) {
      // this.setSelfAssessmentData({ field: event.target.id, value: parseInt(value) })
      var data = {};
      this.updateTotals(); // First: We calculate the totals and update the vuex
      // Create the object to send
      data[event.target.id] = parseInt(event.target.value);
      data["selfAssessment_staff_responsibility_management_subtotal_women"] =
        this.selfAssessment[
          "selfAssessment_staff_responsibility_management_subtotal_women"
        ];
      data[
        "selfAssessment_staff_responsibility_otherPositions_subtotal_women"
      ] =
        this.selfAssessment[
          "selfAssessment_staff_responsibility_otherPositions_subtotal_women"
        ];
      data["selfAssessment_staff_responsibility_total_women"] =
        this.selfAssessment["selfAssessment_staff_responsibility_total_women"];
      data["selfAssessment_staff_department_total_women"] =
        this.selfAssessment["selfAssessment_staff_department_total_women"];
      data["selfAssessment_humanResources_totalStaff_women"] =
        this.selfAssessment["selfAssessment_staff_department_total_women"];
      data["selfAssessment_humanResources_totalNumberStaff_women"] =
        this.selfAssessment["selfAssessment_staff_department_total_women"];
      data["selfAssessment_staff_byDemographics_age_total_women"] =
        this.selfAssessment[
          "selfAssessment_staff_byDemographics_age_total_women"
        ];

      data["selfAssessment_staff_responsibility_management_subtotal_men"] =
        this.selfAssessment[
          "selfAssessment_staff_responsibility_management_subtotal_men"
        ];
      data["selfAssessment_staff_responsibility_otherPositions_subtotal_men"] =
        this.selfAssessment[
          "selfAssessment_staff_responsibility_otherPositions_subtotal_men"
        ];
      data["selfAssessment_staff_responsibility_total_men"] =
        this.selfAssessment["selfAssessment_staff_responsibility_total_men"];
      data["selfAssessment_staff_department_total_men"] =
        this.selfAssessment["selfAssessment_staff_department_total_men"];
      data["selfAssessment_humanResources_totalStaff_men"] =
        this.selfAssessment["selfAssessment_staff_department_total_men"];
      data["selfAssessment_humanResources_totalNumberStaff_men"] =
        this.selfAssessment["selfAssessment_staff_department_total_men"];
      data["selfAssessment_staff_byDemographics_age_total_men"] =
        this.selfAssessment[
          "selfAssessment_staff_byDemographics_age_total_men"
        ];
      // Update the data in the backend
      this.$store.dispatch("SELF_ASSESSMENT_UPDATE", data);
    },
    updateTotals: function () {
      var managementSubtotalWomen =
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_responsibility_management_executiveDirector_women"
          ]
        ) || 0) +
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_responsibility_management_director_women"
          ]
        ) || 0) +
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_responsibility_management_middleLevel4_women"
          ]
        ) || 0) +
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_responsibility_management_middleLevel3_women"
          ]
        ) || 0) +
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_responsibility_management_middleLevel2_women"
          ]
        ) || 0) +
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_responsibility_management_middleLevel1_women"
          ]
        ) || 0);

      var otherPositionsSubtotalWomen =
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_responsibility_otherPositions_technical_women"
          ]
        ) || 0) +
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_responsibility_otherPositions_administrative_women"
          ]
        ) || 0) +
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_responsibility_otherPositions_support_women"
          ]
        ) || 0) +
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_responsibility_otherPositions_operational_women"
          ]
        ) || 0);

      var ResponsabilityTotalWomen =
        managementSubtotalWomen + otherPositionsSubtotalWomen;

      var departmentTotalWomen =
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_department_administration_women"
          ]
        ) || 0) +
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_department_commercial_women"
          ]
        ) || 0) +
        (parseInt(
          this.selfAssessment["selfAssessment_staff_department_logistics_women"]
        ) || 0) +
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_department_production_women"
          ]
        ) || 0) +
        (parseInt(
          this.selfAssessment["selfAssessment_staff_department_technical_women"]
        ) || 0) +
        (parseInt(
          this.selfAssessment["selfAssessment_staff_department_service_women"]
        ) || 0) +
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_department_humanResources_women"
          ]
        ) || 0);

      var demographicSubtotalWomen =
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_byDemographics_age_under18_women"
          ]
        ) || 0) +
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_byDemographics_age_between18And30_women"
          ]
        ) || 0) +
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_byDemographics_age_between31And60_women"
          ]
        ) || 0) +
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_byDemographics_age_older60_women"
          ]
        ) || 0);

      this.setSelfAssessmentData({
        field: "selfAssessment_staff_responsibility_management_subtotal_women",
        value: managementSubtotalWomen,
      });
      this.setSelfAssessmentData({
        field:
          "selfAssessment_staff_responsibility_otherPositions_subtotal_women",
        value: otherPositionsSubtotalWomen,
      });
      this.setSelfAssessmentData({
        field: "selfAssessment_staff_responsibility_total_women",
        value: ResponsabilityTotalWomen,
      });
      this.setSelfAssessmentData({
        field: "selfAssessment_staff_department_total_women",
        value: departmentTotalWomen,
      });
      this.setSelfAssessmentData({
        field: "selfAssessment_staff_byDemographics_age_total_women",
        value: demographicSubtotalWomen,
      });

      // For men

      var managementSubtotalMen =
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_responsibility_management_executiveDirector_men"
          ]
        ) || 0) +
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_responsibility_management_director_men"
          ]
        ) || 0) +
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_responsibility_management_middleLevel4_men"
          ]
        ) || 0) +
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_responsibility_management_middleLevel3_men"
          ]
        ) || 0) +
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_responsibility_management_middleLevel2_men"
          ]
        ) || 0) +
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_responsibility_management_middleLevel1_men"
          ]
        ) || 0);

      var otherPositionsSubtotalMen =
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_responsibility_otherPositions_technical_men"
          ]
        ) || 0) +
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_responsibility_otherPositions_administrative_men"
          ]
        ) || 0) +
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_responsibility_otherPositions_suport_men"
          ]
        ) || 0) +
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_responsibility_otherPositions_operational_men"
          ]
        ) || 0);

      var ResponsabilityTotalMen =
        managementSubtotalMen + otherPositionsSubtotalMen;

      var departmentTotalMen =
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_department_administration_men"
          ]
        ) || 0) +
        (parseInt(
          this.selfAssessment["selfAssessment_staff_department_commercial_men"]
        ) || 0) +
        (parseInt(
          this.selfAssessment["selfAssessment_staff_department_logistics_men"]
        ) || 0) +
        (parseInt(
          this.selfAssessment["selfAssessment_staff_department_production_men"]
        ) || 0) +
        (parseInt(
          this.selfAssessment["selfAssessment_staff_department_technical_men"]
        ) || 0) +
        (parseInt(
          this.selfAssessment["selfAssessment_staff_department_service_men"]
        ) || 0) +
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_department_humanResources_men"
          ]
        ) || 0);

      var demographicSubtotalMen =
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_byDemographics_age_under18_men"
          ]
        ) || 0) +
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_byDemographics_age_between18And30_men"
          ]
        ) || 0) +
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_byDemographics_age_between31And60_men"
          ]
        ) || 0) +
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_byDemographics_age_older60_men"
          ]
        ) || 0);

      this.setSelfAssessmentData({
        field: "selfAssessment_staff_responsibility_management_subtotal_men",
        value: managementSubtotalMen,
      });
      this.setSelfAssessmentData({
        field:
          "selfAssessment_staff_responsibility_otherPositions_subtotal_men",
        value: otherPositionsSubtotalMen,
      });
      this.setSelfAssessmentData({
        field: "selfAssessment_staff_responsibility_total_men",
        value: ResponsabilityTotalMen,
      });
      this.setSelfAssessmentData({
        field: "selfAssessment_staff_department_total_men",
        value: departmentTotalMen,
      });
      this.setSelfAssessmentData({
        field: "selfAssessment_staff_byDemographics_age_total_men",
        value: demographicSubtotalMen,
      });
    },
    updateByGenderResponsabilitySA: function (event, baseVariable, gender) {
      let baseConstant = null;
      let complementaryConstant = null;
      if (
        baseVariable ===
        "SELF_ASSESSMENT_FIELDS_STAFF_RESPONSABILITY_LEADERSHIP"
      ) {
        baseConstant = SELF_ASSESSMENT_FIELDS_STAFF_RESPONSABILITY_LEADERSHIP;
        complementaryConstant =
          SELF_ASSESSMENT_FIELDS_STAFF_RESPONSABILITY_OTHER_POSITIONS;
      }

      if (
        baseVariable ===
        "SELF_ASSESSMENT_FIELDS_STAFF_RESPONSABILITY_OTHER_POSITIONS"
      ) {
        baseConstant =
          SELF_ASSESSMENT_FIELDS_STAFF_RESPONSABILITY_OTHER_POSITIONS;
        complementaryConstant =
          SELF_ASSESSMENT_FIELDS_STAFF_RESPONSABILITY_LEADERSHIP;
      }

      var data = this.updateSATotals(baseConstant, gender);
      const total =
        this.getTotal(baseConstant[gender].fields) +
        this.getTotal(complementaryConstant[gender].fields);
      this.setSelfAssessmentData({
        field: baseConstant[gender].total,
        value: total,
      });
      // data[complementaryConstant[gender].total] = total
      data[event.target.id] = parseInt(event.target.value);
      data[baseConstant[gender].total] = total;

      this.$store.dispatch("SELF_ASSESSMENT_UPDATE", data);
    },
    updateByGenderSA: function (event, baseVariable, gender) {
      const baseConstant = this.getBaseConstantFromDescription(baseVariable);

      var data = this.updateSATotals(baseConstant, gender);
      data[event.target.id] = parseInt(event.target.value);

      this.$store.dispatch("SELF_ASSESSMENT_UPDATE", data);
    },
    updateSATotals: function (variable, gender) {
      const response = {};
      if (variable[gender].subtotal) {
        const subtotal = this.getTotal(variable[gender].fields);
        response[variable[gender].subtotal] = subtotal;
        this.setSelfAssessmentData({
          field: variable[gender].subtotal,
          value: subtotal,
        });
      }

      if (variable[gender].total) {
        const total = this.getTotal(variable[gender].fields);
        response[variable[gender].total] = total;
        this.setSelfAssessmentData({
          field: variable[gender].total,
          value: total,
        });
      }

      return response;
    },
    getTotal: function (correspondingFields) {
      return this.getTotals(correspondingFields);
    },
    ...mapMutations(["setSelfAssessmentData", "setReloadSelfAssessment"]),
  },
  computed: {
    totalAgeWomen: function () {
      var demographicSubtotalWomen =
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_byDemographics_age_under18_women"
          ]
        ) || 0) +
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_byDemographics_age_between18And30_women"
          ]
        ) || 0) +
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_byDemographics_age_between31And60_women"
          ]
        ) || 0) +
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_byDemographics_age_older60_women"
          ]
        ) || 0);
      return demographicSubtotalWomen;
    },
    totalAgeMen: function () {
      var demographicSubtotalMen =
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_byDemographics_age_under18_men"
          ]
        ) || 0) +
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_byDemographics_age_between18And30_men"
          ]
        ) || 0) +
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_byDemographics_age_between31And60_men"
          ]
        ) || 0) +
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_byDemographics_age_older60_men"
          ]
        ) || 0);
      return demographicSubtotalMen;
    },
    totalDesabilitiesWomen: function () {
      var desabilitiesSubtotalMen =
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_byDemographics_disability_yes_women"
          ]
        ) || 0) +
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_byDemographics_disability_no_women"
          ]
        ) || 0);
      return desabilitiesSubtotalMen;
    },
    totalDesabilitiesMen: function () {
      var desabilitiesSubtotalMen =
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_byDemographics_disability_yes_men"
          ]
        ) || 0) +
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_byDemographics_disability_no_men"
          ]
        ) || 0);
      return desabilitiesSubtotalMen;
    },
    totalIdentityWomen: function () {
      var identitySubtotalWomen =
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_byDemographics_ethnicIdentity_afrodescendant_women"
          ]
        ) || 0) +
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_byDemographics_ethnicIdentity_indigenous_women"
          ]
        ) || 0) +
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_byDemographics_ethnicIdentity_asian_women"
          ]
        ) || 0) +
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_byDemographics_ethnicIdentity_hispanic_women"
          ]
        ) || 0) +
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_byDemographics_ethnicIdentity_other_women"
          ]
        ) || 0);
      return identitySubtotalWomen;
    },
    totalIdentityMen: function () {
      var identitySubtotalMen =
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_byDemographics_ethnicIdentity_afrodescendant_men"
          ]
        ) || 0) +
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_byDemographics_ethnicIdentity_indigenous_men"
          ]
        ) || 0) +
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_byDemographics_ethnicIdentity_asian_men"
          ]
        ) || 0) +
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_byDemographics_ethnicIdentity_hispanic_men"
          ]
        ) || 0) +
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_byDemographics_ethnicIdentity_other_men"
          ]
        ) || 0);
      return identitySubtotalMen;
    },
    totalSeniorityWomen: function () {
      var senioritySubtotalWomen =
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_byDemographics_seniority_less2_women"
          ]
        ) || 0) +
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_byDemographics_seniority_between2And5_women"
          ]
        ) || 0) +
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_byDemographics_seniority_between5And10_women"
          ]
        ) || 0) +
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_byDemographics_seniority_more10_women"
          ]
        ) || 0);
      return senioritySubtotalWomen;
    },
    totalSeniorityMen: function () {
      var senioritySubtotalMen =
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_byDemographics_seniority_less2_men"
          ]
        ) || 0) +
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_byDemographics_seniority_between2And5_men"
          ]
        ) || 0) +
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_byDemographics_seniority_between5And10_men"
          ]
        ) || 0) +
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_byDemographics_seniority_more10_men"
          ]
        ) || 0);
      return senioritySubtotalMen;
    },
    totalGenderWomen: function () {
      var genderSubtotalWomen =
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_byDemographics_genderIdentity_womenMen_women"
          ]
        ) || 0) +
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_byDemographics_genderIdentity_transgenderMen_women"
          ]
        ) || 0) +
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_byDemographics_genderIdentity_transgenderWomen_women"
          ]
        ) || 0) +
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_byDemographics_genderIdentity_genderNonConforming_women"
          ]
        ) || 0) +
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_byDemographics_genderIdentity_other_women"
          ]
        ) || 0);
      return genderSubtotalWomen;
    },
    totalGenderMen: function () {
      var gendertotalMen =
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_byDemographics_genderIdentity_womenMen_men"
          ]
        ) || 0) +
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_byDemographics_genderIdentity_transgenderMen_men"
          ]
        ) || 0) +
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_byDemographics_genderIdentity_transgenderWomen_men"
          ]
        ) || 0) +
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_byDemographics_genderIdentity_genderNonConforming_men"
          ]
        ) || 0) +
        (parseInt(
          this.selfAssessment[
            "selfAssessment_staff_byDemographics_genderIdentity_other_men"
          ]
        ) || 0);
      return gendertotalMen;
    },
    ...mapGetters({
      selfAssessment: "getSelfAssessment",
      status: "getSelfAssessmentStatus",
      canUpdateSelfAssessment: "canUpdateSelfAssessment",
      getTotals: "getTotals",
      getBaseConstantFromDescription: "getBaseConstantFromDescription",
      getReloadSelfAssessment: "getReloadSelfAssessment",
    }),
    ...mapFields([
      "selfAssessment_staff_responsibility_management_executiveDirector_women",
      "selfAssessment_staff_responsibility_management_executiveDirector_men",
      "selfAssessment_staff_responsibility_management_director_women",
      "selfAssessment_staff_responsibility_management_director_men",
      "selfAssessment_staff_responsibility_management_middleLevel4_women",
      "selfAssessment_staff_responsibility_management_middleLevel4_men",
      "selfAssessment_staff_responsibility_management_middleLevel3_women",
      "selfAssessment_staff_responsibility_management_middleLevel3_men",
      "selfAssessment_staff_responsibility_management_middleLevel2_women",
      "selfAssessment_staff_responsibility_management_middleLevel2_men",
      "selfAssessment_staff_responsibility_management_middleLevel1_women",
      "selfAssessment_staff_responsibility_management_middleLevel1_men",
      "selfAssessment_staff_responsibility_management_subtotal_women",
      "selfAssessment_staff_responsibility_management_subtotal_men",
      "selfAssessment_staff_responsibility_otherPositions_technical_women",
      "selfAssessment_staff_responsibility_otherPositions_technical_men",
      "selfAssessment_staff_responsibility_otherPositions_administrative_women",
      "selfAssessment_staff_responsibility_otherPositions_administrative_men",
      "selfAssessment_staff_responsibility_otherPositions_support_women",
      "selfAssessment_staff_responsibility_otherPositions_suport_men",
      "selfAssessment_staff_responsibility_otherPositions_operational_women",
      "selfAssessment_staff_responsibility_otherPositions_operational_men",
      "selfAssessment_staff_responsibility_otherPositions_subtotal_women",
      "selfAssessment_staff_responsibility_otherPositions_subtotal_men",
      "selfAssessment_staff_responsibility_total_women",
      "selfAssessment_staff_responsibility_total_men",
      "selfAssessment_staff_department_administration_women",
      "selfAssessment_staff_department_administration_men",
      "selfAssessment_staff_department_commercial_women",
      "selfAssessment_staff_department_commercial_men",
      "selfAssessment_staff_department_logistics_women",
      "selfAssessment_staff_department_logistics_men",
      "selfAssessment_staff_department_production_women",
      "selfAssessment_staff_department_production_men",
      "selfAssessment_staff_department_technical_women",
      "selfAssessment_staff_department_technical_men",
      "selfAssessment_staff_department_service_women",
      "selfAssessment_staff_department_service_men",
      "selfAssessment_staff_department_humanResources_women",
      "selfAssessment_staff_department_humanResources_men",
      "selfAssessment_staff_department_total_women",
      "selfAssessment_staff_department_total_men",
      "selfAssessment_staff_board_women",
      "selfAssessment_staff_board_men",
      "selfAssessment_staff_byDemographics_age_under18_women",
      "selfAssessment_staff_byDemographics_age_under18_men",
      "selfAssessment_staff_byDemographics_age_between18And30_women",
      "selfAssessment_staff_byDemographics_age_between18And30_men",
      "selfAssessment_staff_byDemographics_age_between31And60_women",
      "selfAssessment_staff_byDemographics_age_between31And60_men",
      "selfAssessment_staff_byDemographics_age_older60_women",
      "selfAssessment_staff_byDemographics_age_older60_men",
      "selfAssessment_staff_byDemographics_age_total_women",
      "selfAssessment_staff_byDemographics_age_total_men",
      "selfAssessment_staff_byDemographics_disability_yes_women",
      "selfAssessment_staff_byDemographics_disability_yes_men",
      "selfAssessment_staff_byDemographics_disability_no_women",
      "selfAssessment_staff_byDemographics_disability_no_men",
      "selfAssessment_staff_byDemographics_disability_total_women",
      "selfAssessment_staff_byDemographics_disability_total_men",
      "selfAssessment_staff_byDemographics_ethnicIdentity_afrodescendant_women",
      "selfAssessment_staff_byDemographics_ethnicIdentity_afrodescendant_men",
      "selfAssessment_staff_byDemographics_ethnicIdentity_indigenous_women",
      "selfAssessment_staff_byDemographics_ethnicIdentity_indigenous_men",
      "selfAssessment_staff_byDemographics_ethnicIdentity_total_women",
      "selfAssessment_staff_byDemographics_ethnicIdentity_total_men",
      "selfAssessment_staff_byDemographics_seniority_less2_women",
      "selfAssessment_staff_byDemographics_seniority_less2_men",
      "selfAssessment_staff_byDemographics_seniority_between2And5_women",
      "selfAssessment_staff_byDemographics_seniority_between2And5_men",
      "selfAssessment_staff_byDemographics_seniority_between5And10_women",
      "selfAssessment_staff_byDemographics_seniority_between5And10_men",
      "selfAssessment_staff_byDemographics_seniority_more10_women",
      "selfAssessment_staff_byDemographics_seniority_more10_men",
      "selfAssessment_staff_byDemographics_seniority_total_women",
      "selfAssessment_staff_byDemographics_seniority_total_men",
      "selfAssessment_staff_byDemographics_genderIdentity_womenMen_women",
      "selfAssessment_staff_byDemographics_genderIdentity_womenMen_men",
      "selfAssessment_staff_byDemographics_genderIdentity_transgenderMen_women",
      "selfAssessment_staff_byDemographics_genderIdentity_transgenderMen_men",
      "selfAssessment_staff_byDemographics_genderIdentity_transgenderWomen_women",
      "selfAssessment_staff_byDemographics_genderIdentity_transgenderWomen_men",
      "selfAssessment_staff_byDemographics_genderIdentity_genderNonConforming_women",
      "selfAssessment_staff_byDemographics_genderIdentity_genderNonConforming_men",
      "selfAssessment_staff_byDemographics_genderIdentity_other_women",
      "selfAssessment_staff_byDemographics_genderIdentity_other_men",
      "selfAssessment_staff_byDemographics_genderIdentity_other_description",
      "selfAssessment_staff_byDemographics_genderIdentity_total_women",
      "selfAssessment_staff_byDemographics_ethnicIdentity_asian_women",
      "selfAssessment_staff_byDemographics_ethnicIdentity_asian_men",
      "selfAssessment_staff_byDemographics_ethnicIdentity_hispanic_women",
      "selfAssessment_staff_byDemographics_ethnicIdentity_hispanic_men",
      "selfAssessment_staff_byDemographics_ethnicIdentity_other_women",
      "selfAssessment_staff_byDemographics_ethnicIdentity_other_men",
      "selfAssessment_staff_byDemographics_genderIdentity_total_men",
      "selfAssessment_staff_byDemographics_ethnicIdentity_otherCustom1",
      "selfAssessment_staff_byDemographics_ethnicIdentity_otherCustom2",
      "selfAssessment_staff_byDemographics_ethnicIdentity_otherCustom3",
      "selfAssessment_staff_byDemographics_ethnicIdentity_otherCustom4",
    ]),
  },
};
</script>
<style lang="scss" scoped >
.self-assessment {
  &-table-column {
    align-items: baseline;
    justify-content: flex-end;
  }
}
</style >
